function WarningTemplate({ error }) {
    return (
        <div className="alert alert-warning alert-dismissible " role="alert">
            <button type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button>
            <i className="fas fa-exclamation-circle"></i> {error}
        </div>
    );
}

export default WarningTemplate;